"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { class: "order-modal-container" };
var _hoisted_2 = { class: "order-modal-content" };
var _hoisted_3 = { class: "order-modal-header" };
var _hoisted_4 = { class: "header-content" };
var _hoisted_5 = { class: "patient-info" };
var _hoisted_6 = { class: "avatar-wrapper" };
var _hoisted_7 = ["src"];
var _hoisted_8 = { class: "patient-details" };
var _hoisted_9 = { class: "patient-name" };
var _hoisted_10 = { class: "patient-id" };
var _hoisted_11 = { class: "order-status-wrapper" };
var _hoisted_12 = { class: "order-status-badge" };
var _hoisted_13 = { class: "order-modal-body" };
var _hoisted_14 = ["aria-expanded"];
var _hoisted_15 = { class: "section-title-h4" };
var _hoisted_16 = {
    key: 1,
    class: "section-header"
};
var _hoisted_17 = { class: "section-title-h4" };
var _hoisted_18 = { class: "order-info-body" };
var _hoisted_19 = { class: "medication-card" };
var _hoisted_20 = { class: "medication-name" };
var _hoisted_21 = { class: "medication-description" };
var _hoisted_22 = {
    key: 0,
    class: "prescription-block"
};
var _hoisted_23 = {
    key: 0,
    class: "section-header prescription-subheader"
};
var _hoisted_24 = { class: "prescription-grid" };
var _hoisted_25 = { class: "prescription-item" };
var _hoisted_26 = { class: "prescription-value" };
var _hoisted_27 = { class: "prescription-item" };
var _hoisted_28 = { class: "prescription-value" };
var _hoisted_29 = { class: "prescription-item" };
var _hoisted_30 = { class: "prescription-value" };
var _hoisted_31 = { class: "prescription-item" };
var _hoisted_32 = { class: "prescription-value" };
var _hoisted_33 = { class: "prescription-item" };
var _hoisted_34 = { class: "prescription-value" };
var _hoisted_35 = { class: "prescription-item" };
var _hoisted_36 = { class: "prescription-value" };
var _hoisted_37 = {
    key: 0,
    class: "section provider-section"
};
var _hoisted_38 = { class: "provider-card" };
var _hoisted_39 = { class: "provider-avatar-section" };
var _hoisted_40 = ["src"];
var _hoisted_41 = { class: "provider-name" };
var _hoisted_42 = { class: "specialty-badge" };
var _hoisted_43 = { class: "provider-details" };
var _hoisted_44 = { class: "provider-detail-grid" };
var _hoisted_45 = { class: "provider-detail-item" };
var _hoisted_46 = { class: "detail-value mono" };
var _hoisted_47 = { class: "provider-detail-item" };
var _hoisted_48 = { class: "detail-value email" };
var _hoisted_49 = { class: "provider-detail-item" };
var _hoisted_50 = { class: "detail-value" };
var _hoisted_51 = { class: "provider-detail-item" };
var _hoisted_52 = { class: "detail-value" };
var _hoisted_53 = { class: "section signature-section" };
var _hoisted_54 = {
    key: 0,
    class: "clear-hold-container"
};
var _hoisted_55 = { class: "cancelMeds" };
var _hoisted_56 = {
    key: 1,
    class: "clear-hold-container"
};
var _hoisted_57 = { class: "cancelMeds" };
var _hoisted_58 = { class: "row" };
var _hoisted_59 = { class: "col-sm-6" };
var _hoisted_60 = { class: "signature-body signed" };
var _hoisted_61 = { class: "signature-text" };
var _hoisted_62 = { class: "signature-date" };
var _hoisted_63 = { class: "col-sm-6" };
var _hoisted_64 = {
    key: 0,
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
};
var _hoisted_65 = {
    key: 1,
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
};
var _hoisted_66 = { key: 0 };
var _hoisted_67 = { class: "signature-text" };
var _hoisted_68 = { class: "signature-date" };
var _hoisted_69 = {
    key: 1,
    class: "click-to-sign"
};
var _hoisted_70 = { class: "submit-row" };
var _hoisted_71 = ["disabled"];
var _hoisted_72 = {
    key: 0,
    class: "submit-warning"
};
var _hoisted_73 = { class: "signature-modal" };
var _hoisted_74 = { class: "signature-modal-header" };
var _hoisted_75 = { class: "signature-modal-body" };
var _hoisted_76 = {
    key: 0,
    class: "signature-preview"
};
var _hoisted_77 = { class: "preview-text" };
var _hoisted_78 = { class: "signature-modal-footer" };
var _hoisted_79 = ["disabled"];
var _hoisted_80 = {
    key: 1,
    class: "signature-modal-overlay"
};
var vuex_1 = require("vuex");
var vue_3 = require("vue");
var DiscontinueModal_vue_1 = require("./DiscontinueModal.vue");
var axios_1 = require("axios");
var apis_1 = require("@/constants/apis");
var signatureTimestamp_1 = require("@/utils/signatureTimestamp");
exports.default = (0, vue_1.defineComponent)({
    __name: 'MedadminshortOrderTemplate',
    props: {
        modelValue: {
            type: Boolean,
            default: true
        },
        order: {
            type: Object,
            default: function () { return ({}); }
        }
    },
    emits: [
        'update:modelValue',
        'submitsig',
        'cancelMedHolds',
        'not-approve-order'
    ],
    setup: function (__props, _a) {
        var _this = this;
        var __emit = _a.emit;
        var store = (0, vuex_1.useStore)();
        var allData = (0, vue_3.computed)(function () { var _a; return (_a = store.getters) === null || _a === void 0 ? void 0 : _a['login/getAllData']; });
        var props = __props;
        var emit = __emit;
        var orderRef = (0, vue_3.toRef)(props, 'order');
        var isOpen = (0, vue_3.computed)({
            get: function () { return props.modelValue; },
            set: function (val) { return emit('update:modelValue', val); }
        });
        (0, vue_3.onMounted)(function () {
            console.log("Props Order");
            console.log(orderRef);
            window.addEventListener('resize', updateMobile);
            updateMobile();
        });
        (0, vue_3.onUnmounted)(function () {
            window.removeEventListener('resize', updateMobile);
        });
        var isMobile = (0, vue_3.ref)(typeof window !== 'undefined' && window.innerWidth < 768);
        function updateMobile() {
            isMobile.value = window.innerWidth < 768;
        }
        /** Mobile: medication + prescription start collapsed so signatures are on-screen. */
        var orderInfoExpanded = (0, vue_3.ref)(false);
        var backendAccntType = (0, vue_3.ref)('');
        // Sample data - replace with actual props or API data
        var orderStatus = (0, vue_3.ref)('Active-Pending');
        var medname = (0, vue_3.ref)('');
        var medescription = (0, vue_3.ref)('');
        var patient = (0, vue_3.ref)({
            name: 'John Michael Smith',
            id: 'PT-2024-00847',
            avatar: 'keyon/images/patient_placeholder.svg',
            address: '1234 Oak Street, Apt 5B, Springfield, IL 62701',
            phone: '(217) 555-0123',
            email: 'john.smith@email.com',
            emergencyContact: {
                name: 'Mary Smith',
                relationship: 'Spouse',
                phone: '(217) 555-0456'
            }
        });
        var medication = (0, vue_3.ref)({
            name: 'SUDAFED PE SINUS CONGESTION',
            description: 'Prescribed for relief of nasal and sinus congestion due to seasonal allergies. Patient has reported difficulty breathing and sinus pressure.',
            dosage: '10mg',
            frequency: 'Twice Daily',
            totalPills: '60',
            startDate: '01/15/2026',
            endDate: '02/15/2026',
            physician: 'Dr. Williams'
        });
        var provider = (0, vue_3.ref)({
            name: 'Dr. Sarah Williams, MD',
            specialty: 'Internal Medicine',
            npi: '1234567890',
            email: 'dr.williams@hospital.org',
            phone: '(217) 555-7890',
            fax: '(217) 555-7891',
            avatar: 'keyon/images/patient_placeholder.svg',
            signature: 'Dr. Sarah Williams',
            signedDate: '01/15/2026 at 9:30 AM'
        });
        var shownaApproveModal = (0, vue_3.ref)(false);
        var constDialogTitle = (0, vue_3.ref)('');
        var constDialMsg = (0, vue_3.ref)('');
        var dialogTaxonomy = (0, vue_3.ref)('');
        var nurseSignature = (0, vue_3.ref)('');
        var nurseSignedDate = (0, vue_3.ref)('');
        var providerSignature = (0, vue_3.ref)('');
        var showSignaturePad = (0, vue_3.ref)(false);
        var tempSignature = (0, vue_3.ref)('');
        var ordNumber = (0, vue_3.ref)('');
        var patientdob = (0, vue_3.ref)('');
        var submitaction = (0, vue_3.ref)('');
        var isProcedure = (0, vue_3.ref)(false);
        var isHoldOrder = (0, vue_3.ref)('');
        var mdholdStartdt = (0, vue_3.ref)(''); //set medhol to check if hold is on 
        var cancelOrdernumber = (0, vue_3.ref)('');
        var cancelMedID = (0, vue_3.ref)('');
        var cancelMedName = (0, vue_3.ref)('');
        var notApproveObj = (0, vue_3.ref)({});
        (0, vue_3.watch)(orderRef, function (newOrder, oldOrder) {
            // Handle initial load and updates
            // oldOrder will be undefined on first mount if you want extra safety,
            // but because we didn't set immediate: true this handler won't run on mount.
            if (!newOrder || Object.keys(newOrder).length === 0)
                return;
            // Optional: only run when the id actually changed
            if (oldOrder && (newOrder === null || newOrder === void 0 ? void 0 : newOrder.order_number) === (oldOrder === null || oldOrder === void 0 ? void 0 : oldOrder.order_number))
                return;
            // Your logic when `order` updates
            handleOrderUpdate(newOrder, oldOrder);
            // Fresh open: keep order details collapsed on mobile so signatures stay visible.
            orderInfoExpanded.value = false;
        }, { deep: true, immediate: true });
        (0, vue_3.watch)(isOpen, function (open) {
            if (open)
                orderInfoExpanded.value = false;
        });
        function checkHoldOrderStatus(mdhldstdt) {
            if (mdhldstdt !== "" && String(mdhldstdt) == "Hold") {
                isHoldOrder.value = "Hold";
                dialogTaxonomy.value = isHoldOrder.value;
            }
            else {
                isHoldOrder.value = "Discontinue";
                dialogTaxonomy.value = isHoldOrder.value;
            }
        }
        function submitDCOrder(discText) {
            console.log("Here is the text info that you need to send over");
            console.log(discText);
            emit('not-approve-order', discText, cancelOrdernumber.value, cancelMedID.value, cancelMedName.value, props.order);
        }
        function discontinueOrder(e) {
            //bring up the custom Not Approve Modal
            var checked = e.target.checked;
            if (checked) {
                shownaApproveModal.value = true;
                //now setup dialog text/taxonom/Msg here 
                constDialogTitle.value = "DC Order | Not Approved ";
                constDialMsg.value = "Are you sure you to DC this";
            }
            else {
                //unchecking simply closes modal (if open)
                shownaApproveModal.value = false;
            }
        }
        function cancelCurrentHolds() {
            console.log("Cancel Current Holds");
            console.log(cancelOrdernumber.value);
            console.log("Hold MEcication Name");
            console.log(cancelMedName.value);
            console.log("EditForm MedID");
            console.log(cancelMedID.value);
            console.log("OrderyType is " + " " + isHoldOrder.value);
            var ask = confirm("Are you sure you want to cancel the Medication Hold for " + " " + cancelMedName.value);
            if (ask == true) {
                //emit should go here
                emit('cancelMedHolds', cancelOrdernumber.value, cancelMedID.value, cancelMedName.value);
            }
        }
        function handleOrderUpdate(newOrder, oldOrder) {
            // e.g. open modal, set local refs, fetch related data
            console.log('Order changed:', oldOrder === null || oldOrder === void 0 ? void 0 : oldOrder.order_number, '->', newOrder === null || newOrder === void 0 ? void 0 : newOrder.order_number);
            console.log(newOrder);
            //orderRef.value = newOrder;
            // Determine if this is a procedure based on available fields
            isProcedure.value = !!(newOrder.procedure_code || newOrder.instruction || newOrder.diagnosis_type === 'Procedure');
            // Order status
            orderStatus.value = newOrder.order_status || "N/A";
            // Order number
            ordNumber.value = newOrder.order_number || '';
            // Medication/Procedure information
            if (isProcedure.value) {
                // For procedures: use procedure_code as name, instruction as description
                medication.value.name = newOrder.procedure_code || newOrder.order_medication || '';
                medication.value.description = newOrder.instruction || '';
                medication.value.frequency = '';
                medication.value.dosage = '';
                medication.value.totalPills = '';
            }
            else {
                // For medications
                medication.value.name = newOrder.medname || '';
                medication.value.description = newOrder.orderdescription || '';
                medication.value.frequency = newOrder.med_frequency || '';
                medication.value.dosage = newOrder.med_amount || '';
                medication.value.totalPills = newOrder.total || '';
            }
            medication.value.physician = newOrder.primary_physician || '';
            // Provider information
            provider.value.name = newOrder.primary_physician || '';
            provider.value.npi = newOrder.provider_npi || '';
            provider.value.email = newOrder.provider_email || '';
            provider.value.phone = newOrder.provider_phone || '';
            provider.value.fax = newOrder.provider_fax || '';
            provider.value.signature = newOrder.providersignature || '';
            // Set const to use with html element 
            providerSignature.value = newOrder.providersignature || '';
            nurseSignature.value = newOrder.nursesignature || '';
            mdholdStartdt.value = newOrder.medchangetype || null;
            cancelOrdernumber.value = newOrder.order_number || newOrder.ordernumber;
            cancelMedID.value = newOrder.medentryid;
            cancelMedName.value = newOrder.medname;
            //if hold is on give option to cancel
            checkHoldOrderStatus(mdholdStartdt.value);
            // Signature dates
            if (provider.value.signature === "" || provider.value.signature === null) {
                provider.value.signedDate = '';
            }
            else {
                provider.value.signedDate = newOrder.provsigtimestamp || '';
            }
            if (nurseSignature.value === "" || nurseSignature.value == null) {
                nurseSignedDate.value = '';
            }
            else {
                nurseSignedDate.value = newOrder.nurssigtimestamp || '';
            }
            // Patient information
            var patientAddressParts = [];
            if (newOrder.patient_address)
                patientAddressParts.push(newOrder.patient_address);
            if (newOrder.patient_city)
                patientAddressParts.push(newOrder.patient_city);
            if (newOrder.patient_state)
                patientAddressParts.push(newOrder.patient_state);
            if (newOrder.patient_zip)
                patientAddressParts.push(newOrder.patient_zip);
            patient.value.address = patientAddressParts.join(' ') || '';
            patient.value.phone = newOrder.patient_phone || '';
            patient.value.email = newOrder.patient_email || '';
            patient.value.id = newOrder.patient_id || '';
            patient.value.emergencyContact.name = newOrder.emergency_contactname || '';
            patient.value.emergencyContact.phone = newOrder.emergency_contact_number || '';
            var patientNameParts = [];
            if (newOrder.patient_firstname)
                patientNameParts.push(newOrder.patient_firstname);
            if (newOrder.patient_lastname)
                patientNameParts.push(newOrder.patient_lastname);
            patient.value.name = patientNameParts.join(' ') || '';
            patientdob.value = newOrder.patient_dob || '';
        }
        var closeModal = function () {
            isOpen.value = false;
        };
        /**
         * Signature pad flow (nurse / provider):
         * 1. Click pad → VerifyAccountSignature (license/NPI + registry + name).
         * 2. On failure → alert with backend reason; do NOT open a blank pad (old bug:
         *    pad opened empty and Apply did nothing because backendAccntType stayed unset).
         * 3. On success → pad opens with spaced display name; Apply only if role matches pad.
         */
        /** Which pad the user clicked — used to reject wrong-role attempts after verify. */
        var signingAsRole = (0, vue_3.ref)('');
        /** Verify first, then open pad only when this account can sign that role's field. */
        var openSignaturePad = function (role) { return __awaiter(_this, void 0, void 0, function () {
            var verified;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tempSignature.value = '';
                        backendAccntType.value = '';
                        signingAsRole.value = role;
                        return [4 /*yield*/, verifyAccountSignature()];
                    case 1:
                        verified = _a.sent();
                        if (!verified) {
                            signingAsRole.value = '';
                            return [2 /*return*/];
                        }
                        // Pad role must match verified account_type (RN → nurse pad, Provider → provider pad).
                        if (role === 'nurse' && backendAccntType.value !== 'Registered Nurse') {
                            alert(backendAccntType.value === 'Provider'
                                ? 'A verified Nurse signature is needed for this field. You are signed in as a Provider.'
                                : 'Only a Registered Nurse can sign the Nurse Signature field.');
                            signingAsRole.value = '';
                            return [2 /*return*/];
                        }
                        if (role === 'provider' && backendAccntType.value !== 'Provider') {
                            alert(backendAccntType.value === 'Registered Nurse'
                                ? 'A verified Provider signature is needed for this field. You are signed in as a Registered Nurse.'
                                : 'Only a Provider can sign the Provider Signature field.');
                            signingAsRole.value = '';
                            return [2 /*return*/];
                        }
                        showSignaturePad.value = true;
                        return [2 /*return*/];
                }
            });
        }); };
        /** Apply verified name to the empty signature slot that matches this account's role. */
        var applySignature = function () {
            if (!tempSignature.value || !String(tempSignature.value).trim()) {
                alert('Enter your full name before applying the signature.');
                return;
            }
            // Guard: without a successful verify, Apply used to close the pad and do nothing.
            if (!backendAccntType.value) {
                alert('Your account could not be verified for signing. Close this dialog and try again.');
                showSignaturePad.value = false;
                return;
            }
            // Order already has nurse sig, provider empty → only a Provider may fill it.
            if (providerSignature.value == "" && nurseSignature.value != "" && backendAccntType.value == "Registered Nurse") {
                alert("Sorry, a verified Provider Signature is Needed. ");
            }
            else if (providerSignature.value == "" && nurseSignature.value !== "" && backendAccntType.value == "Provider") {
                providerSignature.value = tempSignature.value;
                provider.value.signature = tempSignature.value;
                submitaction.value = "Update Provider Signature";
                // the stored shape, so it reads like a saved signature - it was a locale string in another format
                provider.value.signedDate = (0, signatureTimestamp_1.signatureStampNow)();
            }
            // Order already has provider sig, nurse empty → only an RN may fill it.
            else if (nurseSignature.value == "" && providerSignature.value != "" && backendAccntType.value == "Registered Nurse") {
                nurseSignature.value = tempSignature.value;
                submitaction.value = "Update Nurse Signature";
                // the stored shape, so it reads like a saved signature - it was a locale string in another format
                nurseSignedDate.value = (0, signatureTimestamp_1.signatureStampNow)();
            }
            else if (nurseSignature.value == "" && providerSignature.value != "" && backendAccntType.value == "Provider") {
                alert("Sorry, a verifed Nurse Signature is needed");
            }
            else {
                alert('Unable to apply this signature for your account type. Please use the signature field that matches your role.');
            }
            showSignaturePad.value = false;
            signingAsRole.value = '';
        };
        var submitOrder = function () {
            if (nurseSignature.value && provider.value.signature != '') {
                emit('submitsig', {
                    nurseSignature: nurseSignature.value,
                    nurseSignedDate: nurseSignedDate.value,
                    patient: patient.value,
                    ordernumber: ordNumber.value,
                    medication: medication.value,
                    provider: provider.value,
                    providerSignedDate: provider.value.signedDate,
                    action: submitaction.value
                });
                //remove signature (Nurse)
                nurseSignature.value = '';
                closeModal();
            }
        };
        /**
         * Calls VerifyAccountSignature.
         * Success (code "1"): prefills tempSignature with spaced name + sets backendAccntType.
         * Failure (code "0"): alerts response.message (license/NPI/registry/name mismatch).
         */
        function verifyAccountSignature() {
            return __awaiter(this, void 0, Promise, function () {
                var content, response, error_1;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            console.log("VIERGY ALL DATA");
                            console.log(allData.value.manager);
                            console.log(allData.value.patient);
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, , 4]);
                            content = {
                                MedicationAdmin: {
                                    API_Meth: "VerifyAccountSignature",
                                    accountnumber: allData.value.patient.externId2, //assuming patient account number aligns with the provider/nurse allData.value.manager.externid2,
                                    provsubaccnt: allData.value.manager.externid,
                                    providername: allData.value.manager.name
                                }
                            };
                            return [4 /*yield*/, axios_1.default.post(apis_1.CURR_API + '/tswebhook.php', content)];
                        case 2:
                            response = _b.sent();
                            console.log('Data posted successfully:', response.data);
                            if (response.data.code == '1' && response.data.accountType && response.data.status == "200 Successfull") {
                                // Spaced display name from backend (comparison still strips spaces server-side).
                                tempSignature.value = response.data.providerName;
                                backendAccntType.value = response.data.accountType;
                                return [2 /*return*/, true];
                            }
                            // Prefer the specific backend message (missing license, no nurses row, name mismatch, etc.).
                            alert(response.data.message ||
                                'Your account could not be verified for signing. Check that your license/NPI and name match your registry record.');
                            return [2 /*return*/, false];
                        case 3:
                            error_1 = _b.sent();
                            if (axios_1.default.isAxiosError(error_1)) {
                                console.error('Error posting data:', ((_a = error_1.response) === null || _a === void 0 ? void 0 : _a.data) || error_1.message);
                            }
                            else {
                                console.error("Error Posting to Past Provider enpoint:", error_1);
                            }
                            alert('Unable to verify your account for signing right now. Please try again.');
                            return [2 /*return*/, false];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }
        return function (_ctx, _cache) {
            return (isOpen.value)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                    key: 0,
                    class: "order-modal-overlay",
                    onClick: (0, vue_2.withModifiers)(closeModal, ["self"])
                }, [
                    (0, vue_2.createElementVNode)("div", _hoisted_1, [
                        (0, vue_2.createElementVNode)("div", _hoisted_2, [
                            (0, vue_2.createElementVNode)("div", _hoisted_3, [
                                (0, vue_2.createElementVNode)("button", {
                                    type: "button",
                                    class: "close-btn",
                                    onClick: closeModal
                                }, __spreadArray([], (_cache[9] || (_cache[9] = [
                                    (0, vue_2.createElementVNode)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "24",
                                        height: "24",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        "stroke-width": "2",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round"
                                    }, [
                                        (0, vue_2.createElementVNode)("line", {
                                            x1: "18",
                                            y1: "6",
                                            x2: "6",
                                            y2: "18"
                                        }),
                                        (0, vue_2.createElementVNode)("line", {
                                            x1: "6",
                                            y1: "6",
                                            x2: "18",
                                            y2: "18"
                                        })
                                    ], -1)
                                ])), true)),
                                (0, vue_2.createElementVNode)("div", _hoisted_4, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_5, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_6, [
                                            (0, vue_2.createElementVNode)("img", {
                                                src: patient.value.avatar || '/keyon/images/placeholder.svg?height=64&width=64',
                                                alt: "Patient",
                                                class: "patient-avatar"
                                            }, null, 8, _hoisted_7),
                                            _cache[10] || (_cache[10] = (0, vue_2.createElementVNode)("span", { class: "status-indicator" }, null, -1))
                                        ]),
                                        (0, vue_2.createElementVNode)("div", _hoisted_8, [
                                            (0, vue_2.createElementVNode)("h2", _hoisted_9, (0, vue_2.toDisplayString)(patient.value.name), 1),
                                            (0, vue_2.createElementVNode)("span", _hoisted_10, " DOB: " + (0, vue_2.toDisplayString)(patientdob.value), 1)
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_11, [
                                        (0, vue_2.createElementVNode)("span", _hoisted_12, [
                                            _cache[11] || (_cache[11] = (0, vue_2.createElementVNode)("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "14",
                                                height: "14",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                stroke: "currentColor",
                                                "stroke-width": "2",
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round"
                                            }, [
                                                (0, vue_2.createElementVNode)("circle", {
                                                    cx: "12",
                                                    cy: "12",
                                                    r: "10"
                                                }),
                                                (0, vue_2.createElementVNode)("polyline", { points: "12 6 12 12 16 14" })
                                            ], -1)),
                                            (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(orderStatus.value), 1)
                                        ]),
                                        _cache[12] || (_cache[12] = (0, vue_2.createStaticVNode)("<div class=\"urgent-indicator\" data-v-0619f6cb><span class=\"pulse-dot\" data-v-0619f6cb></span><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-0619f6cb><path d=\"M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z\" data-v-0619f6cb></path><line x1=\"12\" y1=\"9\" x2=\"12\" y2=\"13\" data-v-0619f6cb></line><line x1=\"12\" y1=\"17\" x2=\"12.01\" y2=\"17\" data-v-0619f6cb></line></svg><span data-v-0619f6cb>Action Required</span></div>", 1))
                                    ])
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_13, [
                                (0, vue_2.createElementVNode)("div", {
                                    class: (0, vue_2.normalizeClass)(["section medication-section", { 'medication-section--collapsed': isMobile.value }])
                                }, [
                                    (isMobile.value)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                            key: 0,
                                            type: "button",
                                            class: "section-header section-header--toggle",
                                            "aria-expanded": orderInfoExpanded.value,
                                            onClick: _cache[0] || (_cache[0] = function ($event) { return (orderInfoExpanded.value = !orderInfoExpanded.value); })
                                        }, [
                                            (0, vue_2.createElementVNode)("h4", _hoisted_15, [
                                                _cache[13] || (_cache[13] = (0, vue_2.createElementVNode)("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    width: "20",
                                                    height: "20",
                                                    viewBox: "0 0 24 24",
                                                    fill: "none",
                                                    stroke: "currentColor",
                                                    "stroke-width": "2",
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round",
                                                    class: "section-icon purple"
                                                }, [
                                                    (0, vue_2.createElementVNode)("path", { d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" })
                                                ], -1)),
                                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(isProcedure.value ? 'Procedure Order Information' : 'Medication Order Information'), 1)
                                            ]),
                                            (0, vue_2.createElementVNode)("span", {
                                                class: (0, vue_2.normalizeClass)(["section-chevron", { open: orderInfoExpanded.value }]),
                                                "aria-hidden": "true"
                                            }, "▾", 2)
                                        ], 8, _hoisted_14))
                                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_16, [
                                            (0, vue_2.createElementVNode)("h4", _hoisted_17, [
                                                _cache[14] || (_cache[14] = (0, vue_2.createElementVNode)("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    width: "20",
                                                    height: "20",
                                                    viewBox: "0 0 24 24",
                                                    fill: "none",
                                                    stroke: "currentColor",
                                                    "stroke-width": "2",
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round",
                                                    class: "section-icon purple"
                                                }, [
                                                    (0, vue_2.createElementVNode)("path", { d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" })
                                                ], -1)),
                                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(isProcedure.value ? 'Procedure Order Information' : 'Medication Order Information'), 1)
                                            ]),
                                            _cache[15] || (_cache[15] = (0, vue_2.createElementVNode)("div", { class: "section-divider purple" }, null, -1))
                                        ])),
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("div", _hoisted_18, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_19, [
                                            (0, vue_2.createElementVNode)("h5", _hoisted_20, (0, vue_2.toDisplayString)(medication.value.name), 1),
                                            (0, vue_2.createElementVNode)("p", _hoisted_21, (0, vue_2.toDisplayString)(medication.value.description), 1)
                                        ]),
                                        (!isProcedure.value)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_22, [
                                                (!isMobile.value)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_23, __spreadArray([], (_cache[16] || (_cache[16] = [
                                                        (0, vue_2.createStaticVNode)("<h4 class=\"section-title-h4\" data-v-0619f6cb><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"section-icon orange\" data-v-0619f6cb><path d=\"M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z\" data-v-0619f6cb></path><polyline points=\"14 2 14 8 20 8\" data-v-0619f6cb></polyline><line x1=\"16\" y1=\"13\" x2=\"8\" y2=\"13\" data-v-0619f6cb></line><line x1=\"16\" y1=\"17\" x2=\"8\" y2=\"17\" data-v-0619f6cb></line><polyline points=\"10 9 9 9 8 9\" data-v-0619f6cb></polyline></svg> Prescription Details </h4>", 1)
                                                    ])), true)))
                                                    : (0, vue_2.createCommentVNode)("", true),
                                                (0, vue_2.createElementVNode)("div", _hoisted_24, [
                                                    (0, vue_2.createElementVNode)("div", _hoisted_25, [
                                                        _cache[17] || (_cache[17] = (0, vue_2.createElementVNode)("span", { class: "prescription-label" }, "Dosage", -1)),
                                                        (0, vue_2.createElementVNode)("span", _hoisted_26, (0, vue_2.toDisplayString)(medication.value.dosage), 1)
                                                    ]),
                                                    (0, vue_2.createElementVNode)("div", _hoisted_27, [
                                                        _cache[18] || (_cache[18] = (0, vue_2.createElementVNode)("span", { class: "prescription-label" }, "Frequency", -1)),
                                                        (0, vue_2.createElementVNode)("span", _hoisted_28, (0, vue_2.toDisplayString)(medication.value.frequency), 1)
                                                    ]),
                                                    (0, vue_2.createElementVNode)("div", _hoisted_29, [
                                                        _cache[19] || (_cache[19] = (0, vue_2.createElementVNode)("span", { class: "prescription-label" }, "Total Pills", -1)),
                                                        (0, vue_2.createElementVNode)("span", _hoisted_30, (0, vue_2.toDisplayString)(medication.value.totalPills), 1)
                                                    ]),
                                                    (0, vue_2.createElementVNode)("div", _hoisted_31, [
                                                        _cache[20] || (_cache[20] = (0, vue_2.createElementVNode)("span", { class: "prescription-label" }, "Start Date", -1)),
                                                        (0, vue_2.createElementVNode)("span", _hoisted_32, (0, vue_2.toDisplayString)(medication.value.startDate), 1)
                                                    ]),
                                                    (0, vue_2.createElementVNode)("div", _hoisted_33, [
                                                        _cache[21] || (_cache[21] = (0, vue_2.createElementVNode)("span", { class: "prescription-label" }, "End Date", -1)),
                                                        (0, vue_2.createElementVNode)("span", _hoisted_34, (0, vue_2.toDisplayString)(medication.value.endDate), 1)
                                                    ]),
                                                    (0, vue_2.createElementVNode)("div", _hoisted_35, [
                                                        _cache[22] || (_cache[22] = (0, vue_2.createElementVNode)("span", { class: "prescription-label" }, "Physician", -1)),
                                                        (0, vue_2.createElementVNode)("span", _hoisted_36, (0, vue_2.toDisplayString)(medication.value.physician), 1)
                                                    ])
                                                ])
                                            ]))
                                            : (0, vue_2.createCommentVNode)("", true)
                                    ], 512), [
                                        [vue_2.vShow, !isMobile.value || orderInfoExpanded.value]
                                    ])
                                ], 2),
                                (!isMobile.value)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_37, [
                                        _cache[27] || (_cache[27] = (0, vue_2.createStaticVNode)("<div class=\"section-header\" data-v-0619f6cb><h4 class=\"section-title-h4\" data-v-0619f6cb><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"section-icon teal\" data-v-0619f6cb><path d=\"M22 10v6M2 10l10-5 10 5-10 5z\" data-v-0619f6cb></path><path d=\"M6 12v5c3 3 9 3 12 0v-5\" data-v-0619f6cb></path></svg> Provider Information </h4></div>", 1)),
                                        (0, vue_2.createElementVNode)("div", _hoisted_38, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_39, [
                                                (0, vue_2.createElementVNode)("img", {
                                                    src: provider.value.avatar || '/placeholder.svg?height=80&width=80',
                                                    alt: "Provider",
                                                    class: "provider-avatar"
                                                }, null, 8, _hoisted_40),
                                                (0, vue_2.createElementVNode)("h5", _hoisted_41, (0, vue_2.toDisplayString)(provider.value.name), 1),
                                                (0, vue_2.createElementVNode)("span", _hoisted_42, (0, vue_2.toDisplayString)(provider.value.specialty), 1)
                                            ]),
                                            (0, vue_2.createElementVNode)("div", _hoisted_43, [
                                                (0, vue_2.createElementVNode)("div", _hoisted_44, [
                                                    (0, vue_2.createElementVNode)("div", _hoisted_45, [
                                                        _cache[23] || (_cache[23] = (0, vue_2.createElementVNode)("span", { class: "detail-label" }, "NPI Number", -1)),
                                                        (0, vue_2.createElementVNode)("span", _hoisted_46, (0, vue_2.toDisplayString)(provider.value.npi), 1)
                                                    ]),
                                                    (0, vue_2.createElementVNode)("div", _hoisted_47, [
                                                        _cache[24] || (_cache[24] = (0, vue_2.createElementVNode)("span", { class: "detail-label" }, "Email", -1)),
                                                        (0, vue_2.createElementVNode)("span", _hoisted_48, (0, vue_2.toDisplayString)(provider.value.email), 1)
                                                    ]),
                                                    (0, vue_2.createElementVNode)("div", _hoisted_49, [
                                                        _cache[25] || (_cache[25] = (0, vue_2.createElementVNode)("span", { class: "detail-label" }, "Phone", -1)),
                                                        (0, vue_2.createElementVNode)("span", _hoisted_50, (0, vue_2.toDisplayString)(provider.value.phone), 1)
                                                    ]),
                                                    (0, vue_2.createElementVNode)("div", _hoisted_51, [
                                                        _cache[26] || (_cache[26] = (0, vue_2.createElementVNode)("span", { class: "detail-label" }, "Fax", -1)),
                                                        (0, vue_2.createElementVNode)("span", _hoisted_52, (0, vue_2.toDisplayString)(provider.value.fax), 1)
                                                    ])
                                                ])
                                            ])
                                        ])
                                    ]))
                                    : (0, vue_2.createCommentVNode)("", true),
                                (0, vue_2.createElementVNode)("div", _hoisted_53, [
                                    _cache[37] || (_cache[37] = (0, vue_2.createStaticVNode)("<div class=\"section-header\" data-v-0619f6cb><h4 class=\"section-title-h4\" data-v-0619f6cb><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"section-icon red\" data-v-0619f6cb><path d=\"M12 19l7-7 3 3-7 7-3-3z\" data-v-0619f6cb></path><path d=\"M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z\" data-v-0619f6cb></path><path d=\"M2 2l7.586 7.586\" data-v-0619f6cb></path><circle cx=\"11\" cy=\"11\" r=\"2\" data-v-0619f6cb></circle></svg> Authorization Signatures </h4></div>", 1)),
                                    (isHoldOrder.value === 'Hold')
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_54, [
                                            (0, vue_2.createElementVNode)("label", _hoisted_55, [
                                                (0, vue_2.createElementVNode)("input", {
                                                    type: "checkbox",
                                                    onChange: cancelCurrentHolds
                                                }, null, 32),
                                                _cache[28] || (_cache[28] = (0, vue_2.createTextVNode)(" Cancel Hold Order? ", -1))
                                            ])
                                        ]))
                                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_56, [
                                            (0, vue_2.createElementVNode)("label", _hoisted_57, [
                                                (0, vue_2.createElementVNode)("input", {
                                                    type: "checkbox",
                                                    onChange: discontinueOrder
                                                }, null, 32),
                                                _cache[29] || (_cache[29] = (0, vue_2.createTextVNode)(" Discontinue Order ", -1))
                                            ])
                                        ])),
                                    (0, vue_2.createElementVNode)("div", _hoisted_58, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_59, [
                                            (0, vue_2.createElementVNode)("div", {
                                                class: (0, vue_2.normalizeClass)(['signature-card', providerSignature.value ? 'signed' : 'pending']),
                                                onClick: _cache[1] || (_cache[1] = function ($event) { return (!providerSignature.value && openSignaturePad('provider')); })
                                            }, [
                                                (0, vue_2.createElementVNode)("div", {
                                                    class: (0, vue_2.normalizeClass)(['signature-header', providerSignature.value ? 'signed' : 'pending'])
                                                }, __spreadArray([], (_cache[30] || (_cache[30] = [
                                                    (0, vue_2.createElementVNode)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        width: "18",
                                                        height: "18",
                                                        viewBox: "0 0 24 24",
                                                        fill: "none",
                                                        stroke: "currentColor",
                                                        "stroke-width": "2",
                                                        "stroke-linecap": "round",
                                                        "stroke-linejoin": "round"
                                                    }, [
                                                        (0, vue_2.createElementVNode)("path", { d: "M22 11.08V12a10 10 0 1 1-5.93-9.14" }),
                                                        (0, vue_2.createElementVNode)("polyline", { points: "22 4 12 14.01 9 11.01" })
                                                    ], -1),
                                                    (0, vue_2.createElementVNode)("span", null, "Provider Signature", -1),
                                                    (0, vue_2.createElementVNode)("span", { class: "verified-badge" }, "Verified", -1)
                                                ])), true), 2),
                                                (0, vue_2.createElementVNode)("div", _hoisted_60, [
                                                    (0, vue_2.createElementVNode)("div", _hoisted_61, (0, vue_2.toDisplayString)(provider.value.signature), 1),
                                                    (0, vue_2.createElementVNode)("div", _hoisted_62, "Signed on " + (0, vue_2.toDisplayString)((0, vue_2.unref)(signatureTimestamp_1.formatSignatureTime)(provider.value.signedDate)), 1)
                                                ])
                                            ], 2)
                                        ]),
                                        (0, vue_2.createElementVNode)("div", _hoisted_63, [
                                            (0, vue_2.createElementVNode)("div", {
                                                class: (0, vue_2.normalizeClass)(['signature-card', nurseSignature.value ? 'signed' : 'pending']),
                                                onClick: _cache[2] || (_cache[2] = function ($event) { return (!nurseSignature.value && openSignaturePad('nurse')); })
                                            }, [
                                                (0, vue_2.createElementVNode)("div", {
                                                    class: (0, vue_2.normalizeClass)(['signature-header', nurseSignature.value ? 'signed' : 'pending'])
                                                }, [
                                                    (nurseSignature.value)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("svg", _hoisted_64, __spreadArray([], (_cache[31] || (_cache[31] = [
                                                            (0, vue_2.createElementVNode)("path", { d: "M22 11.08V12a10 10 0 1 1-5.93-9.14" }, null, -1),
                                                            (0, vue_2.createElementVNode)("polyline", { points: "22 4 12 14.01 9 11.01" }, null, -1)
                                                        ])), true)))
                                                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("svg", _hoisted_65, __spreadArray([], (_cache[32] || (_cache[32] = [
                                                            (0, vue_2.createElementVNode)("path", { d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" }, null, -1),
                                                            (0, vue_2.createElementVNode)("path", { d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" }, null, -1)
                                                        ])), true))),
                                                    _cache[33] || (_cache[33] = (0, vue_2.createElementVNode)("span", null, "Nurse Signature", -1)),
                                                    (0, vue_2.createElementVNode)("span", {
                                                        class: (0, vue_2.normalizeClass)(nurseSignature.value ? 'verified-badge' : 'required-badge')
                                                    }, (0, vue_2.toDisplayString)(nurseSignature.value ? 'Signed' : 'Required'), 3)
                                                ], 2),
                                                (0, vue_2.createElementVNode)("div", {
                                                    class: (0, vue_2.normalizeClass)(['signature-body', nurseSignature.value ? 'signed' : 'pending'])
                                                }, [
                                                    (nurseSignature.value)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_66, [
                                                            (0, vue_2.createElementVNode)("div", _hoisted_67, (0, vue_2.toDisplayString)(nurseSignature.value), 1),
                                                            (0, vue_2.createElementVNode)("div", _hoisted_68, "Signed on " + (0, vue_2.toDisplayString)((0, vue_2.unref)(signatureTimestamp_1.formatSignatureTime)(nurseSignedDate.value)), 1)
                                                        ]))
                                                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_69, __spreadArray([], (_cache[34] || (_cache[34] = [
                                                            (0, vue_2.createStaticVNode)("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"40\" height=\"40\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-0619f6cb><path d=\"M12 19l7-7 3 3-7 7-3-3z\" data-v-0619f6cb></path><path d=\"M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z\" data-v-0619f6cb></path><path d=\"M2 2l7.586 7.586\" data-v-0619f6cb></path><circle cx=\"11\" cy=\"11\" r=\"2\" data-v-0619f6cb></circle></svg><span data-v-0619f6cb>Click to sign</span>", 2)
                                                        ])), true)))
                                                ], 2)
                                            ], 2)
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_70, [
                                        (0, vue_2.createElementVNode)("button", {
                                            type: "button",
                                            class: (0, vue_2.normalizeClass)(['submit-btn', { 'disabled': (!nurseSignature.value || !providerSignature.value) }]),
                                            disabled: (!nurseSignature.value || !providerSignature.value),
                                            onClick: submitOrder
                                        }, __spreadArray([], (_cache[35] || (_cache[35] = [
                                            (0, vue_2.createElementVNode)("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "20",
                                                height: "20",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                stroke: "currentColor",
                                                "stroke-width": "2",
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round"
                                            }, [
                                                (0, vue_2.createElementVNode)("polyline", { points: "20 6 9 17 4 12" })
                                            ], -1),
                                            (0, vue_2.createTextVNode)(" Submit Order Authorization ", -1)
                                        ])), true), 10, _hoisted_71),
                                        ((!nurseSignature.value || !providerSignature.value))
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("p", _hoisted_72, __spreadArray([], (_cache[36] || (_cache[36] = [
                                                (0, vue_2.createElementVNode)("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    width: "14",
                                                    height: "14",
                                                    viewBox: "0 0 24 24",
                                                    fill: "none",
                                                    stroke: "currentColor",
                                                    "stroke-width": "2",
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round"
                                                }, [
                                                    (0, vue_2.createElementVNode)("circle", {
                                                        cx: "12",
                                                        cy: "12",
                                                        r: "10"
                                                    }),
                                                    (0, vue_2.createElementVNode)("line", {
                                                        x1: "12",
                                                        y1: "16",
                                                        x2: "12",
                                                        y2: "12"
                                                    }),
                                                    (0, vue_2.createElementVNode)("line", {
                                                        x1: "12",
                                                        y1: "8",
                                                        x2: "12.01",
                                                        y2: "8"
                                                    })
                                                ], -1),
                                                (0, vue_2.createTextVNode)(" Nurse signature required before submission ", -1)
                                            ])), true)))
                                            : (0, vue_2.createCommentVNode)("", true)
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    (showSignaturePad.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                            key: 0,
                            class: "signature-modal-overlay",
                            onClick: _cache[6] || (_cache[6] = (0, vue_2.withModifiers)(function ($event) { return (showSignaturePad.value = false); }, ["self"]))
                        }, [
                            (0, vue_2.createElementVNode)("div", _hoisted_73, [
                                (0, vue_2.createElementVNode)("div", _hoisted_74, [
                                    _cache[39] || (_cache[39] = (0, vue_2.createStaticVNode)("<h4 data-v-0619f6cb><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-0619f6cb><path d=\"M12 19l7-7 3 3-7 7-3-3z\" data-v-0619f6cb></path><path d=\"M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z\" data-v-0619f6cb></path><path d=\"M2 2l7.586 7.586\" data-v-0619f6cb></path><circle cx=\"11\" cy=\"11\" r=\"2\" data-v-0619f6cb></circle></svg> Enter Your Signature </h4>", 1)),
                                    (0, vue_2.createElementVNode)("button", {
                                        class: "close-btn-small",
                                        onClick: _cache[3] || (_cache[3] = function ($event) { return (showSignaturePad.value = false); })
                                    }, __spreadArray([], (_cache[38] || (_cache[38] = [
                                        (0, vue_2.createElementVNode)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "20",
                                            height: "20",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            stroke: "currentColor",
                                            "stroke-width": "2",
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round"
                                        }, [
                                            (0, vue_2.createElementVNode)("line", {
                                                x1: "18",
                                                y1: "6",
                                                x2: "6",
                                                y2: "18"
                                            }),
                                            (0, vue_2.createElementVNode)("line", {
                                                x1: "6",
                                                y1: "6",
                                                x2: "18",
                                                y2: "18"
                                            })
                                        ], -1)
                                    ])), true))
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_75, [
                                    _cache[41] || (_cache[41] = (0, vue_2.createElementVNode)("label", { for: "nurseNameInput" }, "Full Name", -1)),
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        type: "text",
                                        id: "nurseNameInput",
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) { return ((tempSignature).value = $event); }),
                                        placeholder: "Enter your full name",
                                        class: "signature-input"
                                    }, null, 512), [
                                        [vue_2.vModelText, tempSignature.value]
                                    ]),
                                    (tempSignature.value)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_76, [
                                            _cache[40] || (_cache[40] = (0, vue_2.createElementVNode)("label", null, "Signature Preview", -1)),
                                            (0, vue_2.createElementVNode)("div", _hoisted_77, (0, vue_2.toDisplayString)(tempSignature.value), 1)
                                        ]))
                                        : (0, vue_2.createCommentVNode)("", true)
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_78, [
                                    (0, vue_2.createElementVNode)("button", {
                                        type: "button",
                                        class: "btn-cancel",
                                        onClick: _cache[5] || (_cache[5] = function ($event) { return (showSignaturePad.value = false); })
                                    }, "Cancel"),
                                    (0, vue_2.createElementVNode)("button", {
                                        type: "button",
                                        class: "btn-apply",
                                        disabled: !tempSignature.value,
                                        onClick: applySignature
                                    }, __spreadArray([], (_cache[42] || (_cache[42] = [
                                        (0, vue_2.createElementVNode)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "16",
                                            height: "16",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            stroke: "currentColor",
                                            "stroke-width": "2",
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round"
                                        }, [
                                            (0, vue_2.createElementVNode)("polyline", { points: "20 6 9 17 4 12" })
                                        ], -1),
                                        (0, vue_2.createTextVNode)(" Apply Signature ", -1)
                                    ])), true), 8, _hoisted_79)
                                ])
                            ])
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (shownaApproveModal.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_80, [
                            (0, vue_2.createVNode)(DiscontinueModal_vue_1.default, {
                                parentMsg: constDialMsg.value,
                                titleBar: constDialogTitle.value,
                                ordtaxonomy: dialogTaxonomy.value,
                                onCloseDCModal: _cache[7] || (_cache[7] = function ($event) { return (shownaApproveModal.value = false); }),
                                onCancelDiscontinue: _cache[8] || (_cache[8] = function ($event) { return (shownaApproveModal.value = false); }),
                                onSubmitDiscontinue: submitDCOrder
                            }, null, 8, ["parentMsg", "titleBar", "ordtaxonomy"])
                        ]))
                        : (0, vue_2.createCommentVNode)("", true)
                ]))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
